import type { MetadataPropertyInfoType } from "../../contracts/utils/metadata/MetadataPropertyInfoType";

export class MetadataPropertyInfoTypeType implements MetadataPropertyInfoType {
	constructor(
		private type:
			| "unknown"
			| "boolean"
			| "number"
			| "string"
			| "array"
			| "object"
			| "null"
			| "undefined",
	) {}

	matchType(value: unknown): boolean {
		switch (this.type) {
			case "unknown":
				// any
				return true;
			case "null":
				return value === null;
			case "undefined":
				return value === undefined;
			case "boolean":
				return typeof value === "boolean";
			case "number":
				return typeof value === "number";
			case "string":
				return typeof value === "string";
			case "array":
				return Array.isArray(value);
			case "object":
				return typeof value === "object";
		}
	}

	toString(): string {
		return this.type;
	}
}
